<template>
  <div class="content-item">
    <a-form :form="form" layout="vertical">
      <a-form-item label="Shipper">
        <a-select
          v-decorator="[
            'shipper',
            {
              rules: [
                {
                  required: true,
                  message: 'Please select shipper!',
                },
              ],
            },
          ]"
        >
          <a-select-option :value="shipper" v-for="shipper in providerLst" :key="shipper">{{ shipper }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="Tracking Code">
        <a-input
          v-decorator="[
            'tracking',
            {
              rules: [
                {
                  required: true,
                  message: 'Please input tracking!',
                },
              ],
            },
          ]"
        />
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'UploadProof',

  data() {
    return {
      tracking: '',
      shipper: '',
      providerLst: ['USPS', 'Fedex', 'UPS'],
    };
  },
  computed: {
    ...mapGetters(['settings']),
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, {
      name: 'trackingCode',
    });
  },

  methods: {
    handleSubmit(cb) {
      this.form.validateFields((error, values) => cb(error, values));
    },
  },
};
</script>
